import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24782c98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "WantToBuy" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "titleWarpper" }
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "up" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "down" }
const _hoisted_9 = { class: "left" }
const _hoisted_10 = { class: "detail" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "tag" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("实名认证")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("企业认证")
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "images" }
const _hoisted_18 = { class: "itemFooter" }
const _hoisted_19 = { class: "time" }
const _hoisted_20 = { class: "btns" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("免费报价")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("打电话")
const _hoisted_23 = { class: "notFollow" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "苗搭档", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "找苗、卖苗快人一步 为了匹配更好的求购处理 请关注公众号", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "长安二维码识别关注", -1))
const _hoisted_27 = { class: "notFollow" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "温馨提示", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content1" }, "尊敬的用户，查看信息、免费报价、查看电话等都需要实名认证，请尽快进行身份信息认证！", -1))
const _hoisted_30 = { class: "btn1" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("暂不实名")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("我要实名")
const _hoisted_33 = { class: "notFollow" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "温馨提示", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "尊敬的用户，查看电话需要先对此采购进行报价，尚未报价，请尽快进行报价！", -1))
const _hoisted_36 = { class: "btn" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("暂不报价")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("我要报价")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_40 = { class: "telNum" }
const _hoisted_41 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanSearch = _resolveComponent("VanSearch")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanSwipeItem = _resolveComponent("VanSwipeItem")!
  const _component_VanSwipe = _resolveComponent("VanSwipe")!
  const _component_VanBadge = _resolveComponent("VanBadge")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanPopup = _resolveComponent("VanPopup")!
  const _component_vanButton = _resolveComponent("vanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanSearch, {
      modelValue: $setup.getListData.keyword,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.getListData.keyword) = $event)),
      placeholder: "搜索品种、规格",
      onFocus: _cache[1] || (_cache[1] = ($event: any) => ($setup.isShowSearch = true))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_VanSwipe, {
      autoplay: 3000,
      "indicator-color": "white"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addList, (image) => {
          return (_openBlock(), _createBlock(_component_VanSwipeItem, {
            class: "my-swipe",
            key: image
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: image.bgImage,
                alt: "图片",
                width: "100%",
                height: "100%",
                onClick: ($event: any) => ($setup.router.push({name: "SellerShop", query: {id: image.appUrl.id}}))
              }, null, 8, ["src", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_VanList, {
      class: "list",
      listLoading: $setup.loading,
      "onUpdate:listLoading": _cache[2] || (_cache[2] = ($event: any) => (($setup.loading) = $event)),
      onLoad: $setup.getList,
      "immediate-check": false,
      finished: $setup.finished,
      "finished-text": "没有更多了"
    }, {
      default: _withCtx(() => [
        ($setup.list.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.list, (item, idx) => {
              return (_openBlock(), _createBlock($setup["ListItemAd"], {
                index: idx,
                key: idx
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", {
                    class: "listItem",
                    key: idx,
                    onClick: _withModifiers(($event: any) => ($setup.router.push({name: "BuyDetail", query: {id: item.id}})), ["stop"])
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_VanImage, {
                          src: item.information.avatarUrl,
                          fit: "cover",
                          width: "56",
                          height: "56",
                          round: ""
                        }, null, 8, ["src"]),
                        (item.readed)
                          ? (_openBlock(), _createBlock(_component_VanBadge, {
                              key: 0,
                              content: item.count +1
                            }, {
                              default: _withCtx(() => [
                                (!!item.readed)
                                  ? (_openBlock(), _createBlock(_component_VanImage, {
                                      key: 0,
                                      src: require("@/assets/img/readed.png"),
                                      fit: "cover",
                                      width: "72",
                                      height: "20"
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["content"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", null, _toDisplayString(item.title), 1),
                          _withDirectives(_createElementVNode("span", { class: "num" }, "已有" + _toDisplayString(item.quotations) + "人报价", 513), [
                            [_vShow, item.quotations]
                          ]),
                          (!item.isSubscripte)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                onClick: _withModifiers(($event: any) => {$setup.subscribe(item.categoryId);}, ["stop"]),
                                style: {"font-size":"12pt","color":"#FFF","border":"solid 1px #FF0000","background":"#FF0000","border-radius":"10px","padding":"1px 5px"}
                              }, "点击订阅", 8, _hoisted_7))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.receiptAddress), 1),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", {
                              style: {"color":"#4cc789"},
                              onClick: _withModifiers(($event: any) => ($setup.router.push({name: "BuyDetail", query: {id: item.id}})), ["stop"])
                            }, "查看详情", 8, _hoisted_11)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode($setup["VipTag"], {
                            year: item.years,
                            type: item.vipRank
                          }, null, 8, ["year", "type"]),
                          _withDirectives(_createVNode(_component_VanTag, {
                            size: "small",
                            style: {"width":"48px","overflow":"hidden","word-break":"keep-all"},
                            plain: "",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 2
                          }, 1536), [
                            [_vShow, item.hasIdCard]
                          ]),
                          _withDirectives(_createVNode(_component_VanTag, {
                            size: "small",
                            style: {"width":"48px","overflow":"hidden","word-break":"keep-all"},
                            plain: "",
                            color: "#6775D2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 2
                          }, 1536), [
                            [_vShow, item.hasBusinessLicense]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["area", $setup.classes(idx)]),
                      ref_for: true,
                      ref: $setup.test
                    }, [
                      _createTextVNode("     " + _toDisplayString(item.profile), 1),
                      _withDirectives(_createElementVNode("span", {
                        class: "stow",
                        onClick: _withModifiers(($event: any) => ($setup.show(idx)), ["stop"])
                      }, "收起", 8, _hoisted_15), [
                        [_vShow, !($setup.lineHeightArr[idx]?.showClosing) && $setup.lineHeightArr[idx]?.line >2]
                      ]),
                      _withDirectives(_createElementVNode("span", {
                        class: "closing",
                        onClick: _withModifiers(($event: any) => ($setup.show(idx)), ["stop"])
                      }, "...展开", 8, _hoisted_16), [
                        [_vShow, $setup.lineHeightArr[idx]?.showClosing]
                      ])
                    ], 2),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.photos, (img, imgIdx) => {
                        return (_openBlock(), _createBlock(_component_VanImage, {
                          src: img,
                          alt: "图片",
                          width: "72",
                          height: "72",
                          fit: "cover",
                          radius: "4",
                          onClick: _withModifiers(($event: any) => ($setup.showImg(item.photos, imgIdx)), ["stop"])
                        }, null, 8, ["src", "onClick"]))
                      }), 256))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString($setup.format(Number(item.createTime))), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_VanButton, {
                          type: "default",
                          style: {"border-radius":"15px","border":"solid 1px #33ac9c","color":"#33ac9c"},
                          size: "small",
                          onClick: _withModifiers(($event: any) => ($setup.toQuotedPrice(item.id)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_VanButton, {
                          type: "default",
                          style: {"border-radius":"15px"},
                          size: "small",
                          onClick: _withModifiers(($event: any) => ($setup.call(item.id)), ["stop"]),
                          icon: "phone"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ])
                  ], 8, _hoisted_2))
                ]),
                _: 2
              }, 1032, ["index"]))
            }), 128))
          : (_openBlock(), _createBlock(_component_van_empty, {
              key: 1,
              description: "暂时没有找到供应或正在努力加载..."
            }))
      ]),
      _: 1
    }, 8, ["listLoading", "onLoad", "finished"]),
    _createVNode($setup["SearchCategorie"], {
      modelValue: $setup.isShowSearch,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.isShowSearch) = $event)),
      onSelected: _cache[4] || (_cache[4] = ($event: any) => {$setup.refresh(); $setup.isShowSearch = false}),
      keyword: $setup.getListData.keyword,
      "onUpdate:keyword": _cache[5] || (_cache[5] = ($event: any) => (($setup.getListData.keyword) = $event)),
      onCancel: _cache[6] || (_cache[6] = ($event: any) => {$setup.getListData.keyword = ""; $setup.refresh()})
    }, null, 8, ["modelValue", "keyword"]),
    _createVNode(_component_VanPopup, {
      show: $setup.isNotFollow,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (($setup.isNotFollow) = $event)),
      style: {"width":"80vw","border-radius":"4px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _hoisted_25,
          _createVNode(_component_VanImage, {
            src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/wechat/gzh.jpg",
            style: {"width":"100%"},
            radius: "4"
          }),
          _hoisted_26
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      show: $setup.isRealName,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (($setup.isRealName) = $event)),
      style: {"width":"80vw","border-radius":"4px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.cancelRealName())),
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }),
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.gotoRealName())),
              style: {"border":"solid 1px #f00","margin-left":"20px"},
              type: "danger",
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      show: $setup.IsBaojia,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => (($setup.IsBaojia) = $event)),
      style: {"width":"80vw","border-radius":"4px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.cancelBaoJia())),
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 1
            }),
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.gotoBaoJia({curlId: $setup.curlId}))),
              type: "info",
              style: {"border":"solid 1px #ddd","margin-left":"20px"},
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_38
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, "是否拨打 " + _toDisplayString($setup.tel), 1),
        _createElementVNode("a", {
          class: "call",
          href: `tel:${$setup.tel}`
        }, "立即呼叫", 8, _hoisted_41)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode($setup["RestrictDialog"], {
      modelValue: $setup.restrictShow,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.restrictShow) = $event)),
      code: $setup.restrictCode,
      type: "single"
    }, null, 8, ["modelValue", "code"])
  ]))
}